<template>
    <div style="overflow-x: auto">
        <table class="table b-table" v-for="(proposals, name) in item.proposals">
            <thead class="thead-dark">
                <tr>
                    <th colspan="7">{{ typePerson }}: {{ name }}</th>
                </tr>
                <tr>
                    <th class="text-center">Nº</th>
                    <th class="text-center">Data 1ª PG</th>
                    <th class="text-center">Cliente</th>
                    <th class="text-center">Parcela</th>
                    <th class="text-center">Crédito</th>
                    <th class="text-center">%</th>
                    <th class="text-center">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(proposal, key) in proposals">
                    <td class="text-center">{{ key + 1 }}</td>
                    <td class="text-center">{{ proposal.first_payment_at | moment('DD/MM/YYYY') }}</td>
                    <td>{{ proposal.client_name }}</td>
                    <td class="text-center">{{ proposal.installment }}</td>
                    <td class="text-center">{{ proposal.value | price }}</td>
                    <td class="text-center">{{ item.commision_on_second_installment | price }} %</td>
                    <td class="text-center">{{ getComission(proposal, item.commision_on_second_installment) | price }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="4" class="text-right">Totais</td>
                    <td class="text-center">{{ proposals.reduce((accumulator, proposal) => accumulator + parseFloat(proposal.value), 0) | price }}</td>
                    <td></td>
                    <td class="text-center">{{ getCommissionTotal(proposals, item.commision_on_second_installment) | price }}</td>
                </tr>
                <tr>
                    <td colspan="7"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    export default {
        props: ['item', 'type'],
        computed: {
            typePerson() {
                switch (this.type) {
                    case "manager":
                        return "Gerente";
                        
                    case "after-sale":
                        return "Pós venda";

                    case "supervisor":
                        return "Supervisor";

                    default:
                        return "Vendedor";
                }
            }
        },
        data() {
            return {
                comissaoTotal: 0
            }
        },
        methods: {
            getComission(proposal, commission) {
                let hasCommission = false;

                switch (this.type) {
                    case "manager":
                        hasCommission = proposal.has_surplus_to_manager;
                        break;
                        
                    case "after-sale":
                        hasCommission = proposal.has_surplus_to_after_sale;
                        break;

                    case "supervisor":
                        hasCommission = proposal.has_surplus_to_supervisor;
                        break;

                    default:
                        hasCommission = proposal.has_surplus_to_salesman;
                }

                if (hasCommission) {
                    this.comissaoTotal = this.comissaoTotal + (parseFloat(proposal.value) * commission) / 100;
                    return (parseFloat(proposal.value) * commission) / 100
                }

                return 0
            },
            getCommissionTotal(proposals, commision) {
                let total = 0;
                for (let proposal of proposals){
                    total += this.getComission(proposal, commision);
                }
                return total;
            }
        },
    }
</script>
<style scoped>
    .md-table {
        margin-bottom: 30px;
    }
</style>